module.exports = __webpack_public_path__ + "static/media/uxmap.de431ba2.png";